const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'white',
    height: 55,
    boxShadow: '0 0 1px 0 rgba(0, 0, 0, 0.5)',
    padding: 8,
    position: 'relative',
  },
  container: {
    backgroundColor: 'white',
    position: 'relative',
    zIndex: 1,
    width: '100%',
  },
  iconButton: {
    width: 40,
    height: 40,
    position: 'absolute',
    right: 15,
    zIndex: 2,
  },
  input: {
    width: '75%',
    paddingLeft: 12,
    fontSize: '14px',
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0,
    maxHeight: '70vh',
    overflow: 'scroll',
  },
  suggestion: {
    display: 'block',
    fontSize: '14px',
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
})
export default styles



// WEBPACK FOOTER //
// ./src/Components/GlobalSearch/styles.js